import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class AuthApiService {
	// Simplified auth API methods - can be expanded as needed
	async login(_credentials: { email: string; password: string }) {
		// Mock implementation - replace with actual API calls when needed
		return { success: true, token: 'mock-token' };
	}

	async logout() {
		// Mock implementation
		return { success: true };
	}
}
